import { render } from "./CatsView.vue?vue&type=template&id=6ea0473c"
import script from "./CatsView.vue?vue&type=script&lang=js"
export * from "./CatsView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/cookiemonster/Isaac_Files/Ongoing_Projects/PersonalWebsite/personal_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__